// The map's coordinate readout. A leaf so the precise-location field can format a pose without
// pulling in the WMTS parser it used to share a file with.

const NORTH = 'N'
const SOUTH = 'S'
const EAST = 'E'
const WEST = 'W'
const DEGREE = '°'
const DECIMAL_PLACES = 4

const formatCoordinate = (value: number, isLatitude: boolean): string => {
  const direction = isLatitude
    ? value >= 0
      ? NORTH
      : SOUTH
    : value >= 0
      ? EAST
      : WEST

  const absValue = Math.abs(value)
  const decimalValue = absValue.toFixed(DECIMAL_PLACES)
  return `${decimalValue}${DEGREE}${direction}`
}

export const formatCoordinates = (
  latitude: number,
  longitude: number,
): string => {
  const latFormatted = formatCoordinate(latitude, true)
  const lngFormatted = formatCoordinate(longitude, false)

  return `${latFormatted}, ${lngFormatted}`
}
